import {Image} from 'react-bootstrap';
import book from'../asset/book.png';
import writingPng from'../asset/writing.png';
import readingPng from'../asset/reading.png';
import bigBookPng from'../asset/big-book.png';
import grammarPng from'../asset/grammar.png';
import speakingPng from'../asset/speaking.png';
import listeningPng from'../asset/listening.png';
import listeningBoosterPng from'../asset/listening-booster.png';
import podcastPng from'../asset/podcast.png';
import babyGirlPng from'../asset/baby-girl.png';
import vipPng from'../asset/vip.png';
import teachingNotePng from'../asset/notes.png';
import tipsPng from'../asset/tips.png';
import bankPng from'../asset/bank.png';
import ideaPng from'../asset/idea.png';
import scrabblePng from'../asset/scrabble.png';
import quickSpeakPng from'../asset/quick-speak.png';
import keyVocabListeningPng from'../asset/key-vocab-listening.png';
import keyVocabWritingPng from'../asset/key-vocab-writing.png';
import keyExtraQuestionPng from'../asset/key-extra-question.png';
import listeningExamPng from'../asset/listening-exam.png';
import complexSentencePng from'../asset/complex-sentence.png';
import luckyBagPng from'../asset/shopping-bag.png';
import ieltsSpeakingPng from'../asset/IELTSSpeaking.png';
import literatureReadingPng from'../asset/literatureReading.png';

import PicDescriptionPng from'../asset/picDescription.png';
import InterviewPrepPng from'../asset/InterviewPrep.png';
import ShortTextReadingPng from'../asset/ShortTextReading.png';





export const keyItemList = () => {
	return  [
		{ title: 'Pic-description', searchKey: 'pic-description', itemType:10, availableFormat:[] },
		{ title: 'Interview-Prep', searchKey: 'interview-prep', itemType:11, availableFormat:[] },
		{ title: 'Short-Text-Reading', searchKey: 'short-text-reading', itemType:12, availableFormat:[] },
		{ title: 'Reading', searchKey: 'key-reading', itemType:73, availableFormat:[] },
		{ title: 'Long-Reading', searchKey: 'key-long-reading', itemType:87, availableFormat:[] },
		{ title: 'Literature-Reading', searchKey: 'key-literature-reading', itemType:95, availableFormat:[] },
		{ title: 'Grammar', searchKey: 'key-grammar', itemType:88, availableFormat:[] },
		{ title: 'Speaking', searchKey: 'key-speaking', itemType:72, availableFormat:[] },
		{ title: 'Quick-Speak', searchKey: 'key-quick-speak', itemType:90, availableFormat:[] },
		{ title: 'Writing', searchKey: 'key-writing', itemType:76, availableFormat:[] },
		{ title: 'Listening', searchKey: 'key-listening', itemType:74, availableFormat:[] },
		{ title: 'Listening-Adv', searchKey: 'key-listening-adv', itemType:96, availableFormat:[] },
		{ title: 'Listening-Booster', searchKey: 'key-listening-booster', itemType:97, availableFormat:[] },
		{ title: 'Podcast', searchKey: 'key-podcast', itemType:75, availableFormat:[] },
		{ title: 'Idea', searchKey: 'key-idea', itemType:77, availableFormat:[] },
		{ title: 'Vocab', searchKey: 'key-vocab', itemType:78, availableFormat:[] },
		{ title: 'Vocab-listen', searchKey: 'key-vocab-listen', itemType:79, availableFormat:[] },
		{ title: 'Vocab-writing', searchKey: 'key-vocab-writing', itemType:80, availableFormat:[] },
		{ title: 'VIP-writing', searchKey: 'key-vip-writing', itemType:81, availableFormat:[] },
		{ title: 'Teaching-note', searchKey: 'key-teaching-note', itemType:82, availableFormat:[] },
		{ title: 'Tips-bag', searchKey: 'key-tips-bag', itemType:83, availableFormat:[] },
		{ title: 'Word-bank', searchKey: 'key-word-bank', itemType:89, availableFormat:[] },
		{ title: 'Extra-Question', searchKey: 'key-extra-question', itemType:91, availableFormat:[] },
		{ title: 'Listening-Partb', searchKey: 'key-listening-partb', itemType:92, availableFormat:[] },
		{ title: 'Complex-Sentence', searchKey: 'key-complex-sentence', itemType:93, availableFormat:[] },
		{ title: 'IELTS-Speaking', searchKey: 'key-ielts-speaking', itemType:94, availableFormat:[] },
		{ title: 'Lucky-Bag', searchKey: 'key-lucky-bag', itemType:84, availableFormat:[] },
	];
}

export const VoiceListJunior = [
{speaker:"en-GB-Chirp3-HD-Laomedeia",gender:"FEMALE", speakingRate:"0.75", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Rasalgethi",gender:"MALE", speakingRate:"0.76", age:"young"},
{speaker:"en-GB-Chirp3-HD-Iapetus",gender:"MALE", speakingRate:"0.77", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Fenrir",gender:"MALE", speakingRate:"0.78", age:"young"},
{speaker:"en-GB-Chirp3-HD-Algieba",gender:"MALE", speakingRate:"0.78", age:"eldly"},
{speaker:"en-GB-Chirp3-HD-Algenib",gender:"MALE", speakingRate:"0.77", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Achird",gender:"MALE", speakingRate:"0.77", age:"young"},
{speaker:"en-GB-Chirp3-HD-Sulafat",gender:"FEMALE", speakingRate:"0.76", age:"young"},
{speaker:"en-GB-Chirp3-HD-Gacrux",gender:"FEMALE", speakingRate:"0.77", age:"eldly"},
{speaker:"en-GB-Chirp3-HD-Callirrhoe",gender:"FEMALE", speakingRate:"0.77", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Autonoe",gender:"FEMALE", speakingRate:"0.77", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Aoede",gender:"FEMALE", speakingRate:"0.78", age:"young"},
]
export const VoiceListSenior = [
{speaker:"en-GB-Chirp3-HD-Rasalgethi",gender:"MALE", speakingRate:"0.86", age:"young"},
{speaker:"en-GB-Chirp3-HD-Iapetus",gender:"MALE", speakingRate:"0.87", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Fenrir",gender:"MALE", speakingRate:"0.88", age:"young"},
{speaker:"en-GB-Chirp3-HD-Algieba",gender:"MALE", speakingRate:"0.88", age:"eldly"},
{speaker:"en-GB-Chirp3-HD-Algenib",gender:"MALE", speakingRate:"0.87", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Achird",gender:"MALE", speakingRate:"0.87", age:"young"},
{speaker:"en-GB-Chirp3-HD-Sulafat",gender:"FEMALE", speakingRate:"0.86", age:"young"},
{speaker:"en-GB-Chirp3-HD-Gacrux",gender:"FEMALE", speakingRate:"0.87", age:"eldly"},
{speaker:"en-GB-Chirp3-HD-Callirrhoe",gender:"FEMALE", speakingRate:"0.87", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Autonoe",gender:"FEMALE", speakingRate:"0.87", age:"mid age"},
{speaker:"en-GB-Chirp3-HD-Aoede",gender:"FEMALE", speakingRate:"0.88", age:"young"},
{speaker:"en-GB-Chirp3-HD-Enceladus",gender:"MALE", speakingRate:"0.85", age:"mid age"},
]

export const ItemConstant = {
	NonSubThemeIts:[76,84],
	ListeningLabelIts:[74,75,96,97],
	PaperIts:[87],
	NoteTypeIts:[82,83],
	DisplayModeIts:[73,95],
	MagicPenNoteIts:[77],
	TeacherOnlyNotesIts:[82],
	CodeIts:[72,94,73,95,74,75,81,82,83,84,87,88,89,90, 92, 96,97],
	TextType:[72,94,73,95,76,81,82,83,84,87,88,89,90],
	LabelSkillIts:[73,95,81,84,87,88,89],
	BasicCreateShortCutIts:[10,11,12,70,72,94,73,95,76,77,81,82,83,87, 89,90],
	ReadingIts:[73,95,87],
	SpeakingIts:[72,73, 94,90, 95],
	
	IdeaIts:[77],
	ListeningPartbIts:[92],
	VIPWritingIts:[81],
	ComplexSentenceIts:[93],
	VocabIts:[78,79,80],
	SpeakingAnswerIts:[72,73, 94,82,83,90, 95],
	BookItemIts:[10,11,12,70,72,94,73,95,76,77,78,79,80,81,82,87,88,89,90, 93],
	AllKeyItemIts:[10,11,12,72,94,73,95,74,75,76,77,78,79,80,81,82,83,84, 87,88,89,90, 91, 92, 93, 96,97],
	AllItemIts:[10,11,12,70,72,94,73,95,74,75,76,77,78,79,80,81,82,83,84, 87,88,89,90, 91, 92, 93, 96,97],
	
	grammarIts:[88,89],
	readingIts:[10,11,12,73,95,87],
}

export const SectionList = [
	"DSE Part A",
	"DSE Part B",
	"DSE Part B1",
	"DSE Part B2",	
	"Junior Part A",
	"Junior Part B",
	"Junior Part B1",
	"Junior Part B2",	
]

export const TextTypeList = [

"Social issues/Social trend",
"Youth trend/Youth issue",
"Social media",
"Popular culture",
"Tech ethics",
"Advice/Suggestion to youth",
"Youth experience sharing",
"Proposal/Design/Activity organizing",
"School related",
"HK Culture/Uniqueness",
"Workplace/Career",
"Sport related",





"Activity organizing",
"Advertisement",
"Advice",
"Advice column",
"Announcement",
"Application form",
"Application letter",
"Blog entry",
"Book review",
"Career",
"Complaint letter",
"Design",
"Email",
"Event plan",
"Film review",
"Generation Gap",
"Guide to visitors",
"HK Culture",
"Informative letter",
"Invitation letter",
"Leaflet",
"Letter of appreciation",
"Letter to editor",
"Letter to parents on school trip",
"Newsletter article",
"Notice",
"Other review",
"Persuasive letter",
"Press Release",
"Presentation script",
"Problem-solution essay",
"Profile",
"Proposal",
"Questionnaire",
"Report",
"Restaurant review",
"Reply to complaint letter",
"Social issues",
"Social trend",
"Speech",
"Suggestion to youth",
"Uniqueness",
"Vlog script",
"Workplace",
"Yearbook entry",
"Youth issue",
"Youth trend",
	"Others"
]

export const SessionSetting = [
	{configKey:"writing", dbKey:"writing", configName:"Writing"},
	{configKey:"azureReadOutLoud", dbKey:"azure_read_out_loud", configName:"Azure Read Out Loud"},
	{configKey:"reading", dbKey:"reading", configName:"Reading"},
	{configKey:"longReading", dbKey:"long_reading", configName:"Long Reading"},
	{configKey:"literatureReading", dbKey:"literature-reading", configName:"Literature Reading"},
	{configKey:"speaking", dbKey:"speaking", configName:"Speaking"},
	{configKey:"listening", dbKey:"listening", configName:"Listening"},
	{configKey:"listeningAdv", dbKey:"listeningAdv", configName:"Listening Adv"},
	{configKey:"idea", dbKey:"idea", configName:"Idea"},
	{configKey:"grammar", dbKey:"grammar", configName:"Grammar"},
	{configKey:"wordBank", dbKey:"word_bank", configName:"Word Bank"},
	{configKey:"vipWriting", dbKey:"vip_writing", configName:"VIP writing"},
	{configKey:"teachingNote", dbKey:"teaching_note", configName:"Teaching Note"},
	{configKey:"listeningPartb", dbKey:"listening_partb", configName:"Teaching Note"},
	{configKey:"complexSentence", dbKey:"complex_sentence", configName:"Complex Sentence"},
	{configKey:"ieltsSpeaking", dbKey:"ielts_speaking", configName:"IELTS Speaking"},
]

export const ItemObjectList = [
	{itemType:10, name:"Pic. desc."},
	{itemType:11, name:"Interview Prep - Q & A"},
	{itemType:12, name:"Short Text Reading"},
	{itemType:70, name:"Book"},
	{itemType:72, name:"Speaking"},
	{itemType:73, name:"Reading"},
	{itemType:74, name:"Listening"},
	{itemType:96, name:"Listening-Adv"},
	{itemType:97, name:"Listening-Booster"},
	{itemType:75, name:"Podcast"},
	{itemType:76, name:"Writing"},
	{itemType:77, name:"Idea"},
	{itemType:78, name:"Vocab"},
	{itemType:79, name:"Vocab-listen"},
	{itemType:80, name:"Vocab-writing"},
	{itemType:81, name:"VIP-writing"},
	{itemType:82, name:"Teaching-note"},
	{itemType:83, name:"Tips-bag"},
	{itemType:87, name:"Long-Reading"},
	{itemType:88, name:"Grammar"},
	{itemType:89, name:"Word-Bank"},
	{itemType:90, name:"Quick-Speak"},
	{itemType:91, name:"Extra-Question"},
	{itemType:92, name:"Listening-Partb"},
	{itemType:93, name:"Complex-Sentence"},
	{itemType:94, name:"IELTS-Speaking"},
	{itemType:95, name:"Literature-Reading"},
	{itemType:84, name:"Lucky-Bag"},
]

export const getItemBasic = (itemType) => {

		switch(itemType) {
			case 10: return {itemType:10, name:"Pic description"};
			case 11: return {itemType:11, name:"Interview Prep"};
			case 12: return {itemType:12, name:"Short Text Reading"};
			case 70: return {itemType:70, name:"Book"};
			case 72: return {itemType:72, name:"Speaking"};
			case 73: return {itemType:73, name:"Reading"};
			case 74: return {itemType:74, name:"Listening"};
			case 96: return {itemType:96, name:"Listening-adv"};
			case 97: return {itemType:97, name:"Listening-Booster"};
			case 75: return {itemType:75, name:"Podcast"};
			case 76: return {itemType:76, name:"Writing"};
			case 77: return {itemType:77, name:"Key-Idea" };
			case 78: return {itemType:78, name:"Key-Vocab" };
			case 79: return {itemType:79, name:"Key-Vocab-listening" };
			case 80: return {itemType:80, name:"Key-Vocab-writing" };
			case 81: return {itemType:81, name:"VIP-writing" };
			case 82: return {itemType:82, name:"Teaching Note" };
			case 83: return {itemType:83, name:"Tips bag" };
			case 87: return {itemType:87, name:"Long-Reading"};
			case 88: return {itemType:88, name:"Grammar"};
			case 89: return {itemType:89, name:"Word-Bank"};
			case 90: return {itemType:90, name:"Quick-Speak"};
			case 91: return {itemType:91, name:"Extra-Question"};
			case 92: return {itemType:92, name:"Listening-Partb"};
			case 93: return {itemType:93, name:"Complex-Sentence"};
			case 94: return {itemType:94, name:"IELTS-Speaking"};
			case 95: return {itemType:95, name:"Literature-Reading"};
			case 84: return {itemType:84, name:"Lucky-Bag"};
			
			default: return { itemType: -1, name: "???" }; // Default case
		}
}

export const ItemTypeIcon = ({itemType}) => {
	
	switch(itemType) {
		case 10:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={PicDescriptionPng} rounded />	);				
		case 11:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={InterviewPrepPng} rounded />	);				
		case 12:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={ShortTextReadingPng} rounded />	);				
		



		case 51:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={babyGirlPng} rounded />	);				
		case 72: // speaking
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={speakingPng} rounded />	);				
		case 90: // quick-speak
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={quickSpeakPng} rounded />	);
		case 87: // long-reading
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={bigBookPng} rounded />	);
		case 88: // grammar
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={grammarPng} rounded />	);
		case 73: // reading
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={readingPng} rounded />	);
		case 74: // listening
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={listeningPng} rounded />	);
		case 96: // listeningAdv
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={listeningPng} rounded />	);
		case 97: // listeningBooster
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={listeningBoosterPng} rounded />	);
		case 75: // pod class
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={podcastPng} rounded />	);
		case 76: // writing class
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={writingPng} rounded />	);
		case 77:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={ideaPng} rounded />	);
		case 78:
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={scrabblePng} rounded />	);
		case 79: // vocab class
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={keyVocabListeningPng} rounded />	);
		case 80: // vocab class
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={keyVocabWritingPng} rounded />	);
		case 81: // VIP writing
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={vipPng} rounded />	);
		case 82: // Teaching Note
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={teachingNotePng} rounded />	);
		case 83: // Tips bag
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={tipsPng} rounded />	);	
		case 89: // Word Bank
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={bankPng} rounded />	);		
		case 91: // Extra-Question
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={keyExtraQuestionPng} rounded />	);		
		case 92: // Listening Exam PNG
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={listeningExamPng} rounded />	);				
		case 93: // Complex Sentence PNG
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={complexSentencePng} rounded />	);	
		case 94: // IELTS speaking
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={ieltsSpeakingPng} rounded />	);		
		case 95: // Literature-Reading
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={literatureReadingPng} rounded />	);		
		case 84: // Lucky-Bag
			return (
			<Image style={{width:"25px",height:"25px"}} fluid
				src={luckyBagPng} rounded />	);				
		default :
			return (
			<Image  style={{width:"25px",height:"25px"}} fluid
				src={book} rounded />	);
	}
}


/*
case 1: obj['itemType'] = 70; break;
case 2: obj['itemType'] = 72; break;
case 3: obj['itemType'] = 73; break;
case 4: obj['itemType'] = 74; break;
case 5: obj['itemType'] = 75; break;
case 6: obj['itemType'] = 76; break;
case 7: obj['itemType'] = 77; break;
case 8: obj['itemType'] = 78; break;
case 9: obj['itemType'] = 79; break;
case 10: obj['itemType'] = 80; break;
case 11: obj['itemType'] = 81; break;
case 12: obj['itemType'] = 82; break;
case 13: obj['itemType'] = 83; break;
case 14: obj['itemType'] = 87; break;
case 15: obj['itemType'] = 88; break;


[1,2,3,6,7, 11, 12, 13, 14]
[70,72,73,76,77,81,82,83,87]

73, 87*/